import { React, useState, useEffect } from "react";

import classes from "./ArtExpandedView.module.css";

function ArtExpandedView({ project }) {

    const [mediaData, setMediaData] = useState([]);

    useEffect(() => {
        const loadMedia = async () => {
            const response = await fetch(`${project.screenshotPath}/media.json`);
            if (!response.ok) {
                console.error(`Failed to load media for ${project.name}`);
                return;
            }
            const files = await response.json();
            const media = files.map(file => {
                const ext = file.split('.').pop().toLowerCase();
                const isVideo = ['mp4', 'webm', 'ogg'].includes(ext);
                return {
                    url: `${project.screenshotPath}/${file}`,
                    video: isVideo
                };
            });
            setMediaData(media);
        };

        loadMedia();
    }, [project.screenshotPath]);

    return (
        <div className={classes.expandedView}>
            <div className={classes.topSection}>
                {project.ytLink ?
                    project.ytLink
                    :
                    mediaData.map((item) => (
                        <div className={classes.imageContainer}>
                            {item.video ? (
                                <video autoPlay loop muted playsInline className={classes.image}>
                                    <source src={item.url} type={`video/${item.url.split('.').pop()}`} />
                                </video>
                            ) : (
                                <img className={classes.image} src={item.url} />
                            )}
                        </div>
                    ))
                }
            </div>
            <div className={classes.description}>
                {project.description}
            </div>
        </div>
    );
}

export default ArtExpandedView;